var PASARGADELECTRIC = {
  name: "PASARGAD ELECTRIC",
  defaultCommandIndex: 1,
  commands: [
     {
      mode: "AC_MODE_OFF",
      temperature: "AC_TEMP_NULL",
      fan: "AC_FAN_NULL",
      command: [227,0,5,72,2,236,0,49,12,40,6,82,2,50,4,100,2,52,1,100,2,0,0,73,140,228,206,76,145,152,156,120,241,227,198,98,76,124,146,120,153,30,60,120,241,227,199,143,30,57,57,132],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_16",
      fan: "AC_FAN_AUTO",
      command: [227,0,5,66,2,249,0,15,12,56,6,71,2,51,4,86,2,65,1,94,2,0,0,73,140,228,206,76,156,231,30,60,120,231,49,38,62,73,60,120,241,227,199,143,30,60,120,241,38,115,8],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_17",
      fan: "AC_FAN_AUTO",
      command: [227,0,5,61,2,15,1,38,12,61,6,53,2,68,4,75,2,130,1,64,2,0,0,73,231,38,114,100,231,63,255,243,152,147,252,147,255,255,255,255,255,243,57,132],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_AUTO",
      command: [227,0,5,63,2,19,1,43,12,53,6,68,2,61,4,64,2,93,1,72,2,0,0,73,231,38,114,100,140,231,255,254,115,18,127,50,127,255,255,255,255,252,231,48,128],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_AUTO",
      command: [227,0,5,54,2,255,0,25,12,91,6,31,2,88,4,81,2,73,1,57,2,0,0,73,140,196,153,201,146,51,19,143,30,49,142,70,98,76,120,228,241,227,199,143,30,60,120,241,227,199,156,194],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_AUTO",
      command: [227,0,5,48,2,7,1,37,2,80,4,18,12,86,6,46,2,81,1,69,2,0,0,43,27,21,186,212,108,92,120,241,227,163,98,177,245,191,255,255,255,252,120,250,189,132],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_AUTO",
      command: [227,0,5,55,2,21,1,74,12,55,6,63,2,68,4,78,2,120,1,71,2,0,0,73,140,228,206,76,156,231,31,255,206,98,79,243,63,255,255,255,255,255,39,152,64],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_AUTO",
      command: [227,0,5,61,2,13,1,40,12,67,6,52,2,72,4,74,2,81,1,62,2,0,0,73,231,38,114,100,231,63,248,254,115,18,127,57,255,255,255,227,255,254,103,152,64],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_AUTO",
      command: [227,0,5,70,2,255,0,37,12,53,6,77,2,64,4,81,2,67,1,86,2,0,0,73,231,38,114,100,231,63,143,30,57,204,73,248,243,252,120,241,227,199,143,30,60,120,231,152,64],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_AUTO",
      command: [227,0,5,61,2,251,0,37,12,73,6,44,2,69,4,74,2,66,1,65,2,0,0,73,140,196,153,201,146,51,19,143,30,60,114,51,18,99,196,146,60,120,241,227,199,143,30,60,120,241,38,57,16,128],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_AUTO",
      command: [227,0,5,68,2,244,0,32,12,50,6,75,2,57,4,100,2,55,1,79,2,0,0,73,140,228,206,76,156,231,30,60,120,231,49,39,227,39,199,143,30,60,120,241,227,199,143,25,142,97,0],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_AUTO",
      command: [227,0,5,67,2,254,0,37,12,53,6,75,2,47,4,88,2,74,1,111,2,0,0,73,140,228,206,76,156,231,241,227,199,57,137,63,153,241,227,199,143,30,60,120,241,227,231,28,194],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_AUTO",
      command: [227,0,5,67,2,3,1,43,12,43,6,81,2,52,4,74,2,69,1,94,2,0,0,73,231,38,114,100,231,63,143,30,57,204,73,248,231,252,120,241,227,252,120,241,255,227,152,64],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_AUTO",
      command: [227,0,5,68,2,240,0,47,12,43,6,79,2,52,4,90,2,66,1,88,2,0,0,73,140,228,206,76,156,231,30,60,120,231,49,38,60,73,248,241,227,199,143,30,60,120,241,226,73,36,196,32],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_AUTO",
      command: [227,0,5,63,2,248,0,16,12,59,6,69,2,53,4,90,2,68,1,81,2,0,0,73,231,38,114,100,231,56,241,227,199,57,137,49,227,49,227,199,143,30,60,120,241,227,199,140,146,78,16],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_AUTO",
      command: [227,0,5,68,2,243,0,40,12,51,6,80,2,41,4,87,2,59,1,78,2,0,0,73,231,38,114,100,231,56,241,227,199,35,49,38,60,78,60,120,241,227,199,143,30,60,120,241,50,73,194],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_31",
      fan: "AC_FAN_AUTO",
      command: [227,0,5,67,2,1,1,32,12,50,6,72,2,56,4,86,2,67,1,70,2,0,0,73,140,228,206,76,156,231,30,60,120,231,49,39,227,199,143,30,60,120,241,227,199,143,30,57,36,225,0],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_16",
      fan: "AC_FAN_LOW",
      command: [227,0,5,56,2,17,1,47,2,67,4,31,12,78,6,72,2,93,1,64,2,0,0,43,221,110,181,221,255,255,163,98,191,170,253,255,255,255,255,253,174,194],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_17",
      fan: "AC_FAN_LOW",
      command: [227,0,5,249,11,96,6,31,2,92,4,44,2,247,0,69,2,72,1,69,2,0,0,169,18,145,82,146,165,68,164,82,34,68,68,68,68,68,136,148,74,69,72,146,68,170,73,18,145,36,137,36,73,34,73,18,72,146,68,146,36,145,36,137,42,74,66],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_LOW",
      command: [227,0,5,54,2,20,1,54,2,76,4,33,12,61,6,71,2,132,1,61,2,0,0,43,221,110,181,221,255,255,187,21,253,175,223,255,255,255,248,250,221,132],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_LOW",
      command: [227,0,5,45,2,23,1,31,12,61,6,57,2,76,4,65,2,131,1,63,2,0,0,73,231,38,114,100,231,63,255,243,152,147,254,79,207,255,255,255,255,243,57,132],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_LOW",
      command: [227,0,5,58,2,22,1,39,12,74,6,46,2,73,4,65,2,95,1,67,2,0,0,73,231,38,114,100,140,231,255,254,115,18,127,38,126,127,255,255,255,255,57,204,32],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_LOW",
      command: [227,0,5,52,2,21,1,35,12,68,6,51,2,67,4,104,2,112,1,79,2,0,0,73,231,38,114,100,231,63,255,243,152,147,252,207,25,255,143,255,255,255,243,152,64],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_LOW",
      command: [227,0,5,58,2,23,1,43,12,52,6,59,2,73,4,68,2,121,1,70,2,0,0,73,231,38,114,100,231,63,255,243,152,147,249,207,207,255,255,255,255,228,158,97,0],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_LOW",
      command: [227,0,5,66,2,2,1,44,12,58,6,75,2,47,4,72,2,70,1,77,2,0,0,73,231,38,114,100,231,56,241,227,199,57,137,63,30,120,207,199,143,30,60,120,241,227,198,72,230,16],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_LOW",
      command: [227,0,5,66,2,255,0,36,12,57,6,73,2,51,4,73,2,77,1,64,2,0,0,73,231,38,114,100,231,56,241,227,199,57,137,63,146,124,103,227,199,143,30,60,120,241,226,103,152,64],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_LOW",
      command: [227,0,5,34,12,73,6,63,2,246,0,45,2,70,4,84,2,63,1,88,2,0,0,146,138,81,37,42,74,72,165,18,162,168,170,42,138,145,74,36,162,162,41,42,162,148,85,21,69,81,84,85,21,69,81,84,85,21,42,148,32],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_LOW",
      command: [227,0,5,61,2,241,0,33,12,74,6,43,2,73,4,83,2,68,1,84,2,0,0,73,140,196,153,201,146,51,19,143,30,56,142,70,98,76,124,200,241,152,241,227,196,113,227,199,136,226,60,152,140,194],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_LOW",
      command: [227,0,5,57,2,21,1,49,2,71,4,48,12,73,6,70,2,116,1,72,2,0,0,43,27,173,214,187,191,255,247,98,191,239,239,255,255,255,255,247,216,64],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_LOW",
      command: [227,0,5,52,2,23,1,63,2,73,4,34,12,54,6,69,2,122,1,72,2,0,0,43,221,110,181,221,255,199,247,98,177,245,254,255,255,255,255,254,253,132],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_LOW",
      command: [227,0,5,57,2,24,1,65,2,61,4,43,12,57,6,69,2,117,1,73,2,0,0,43,221,110,181,221,255,255,187,21,254,255,127,255,255,255,255,253,132],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_LOW",
      command: [227,0,5,54,2,25,1,42,12,66,6,54,2,69,4,73,2,129,1,55,2,0,0,73,231,38,114,100,231,63,255,243,152,147,249,255,63,255,255,255,255,146,73,56,64],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_31",
      fan: "AC_FAN_LOW",
      command: [227,0,5,57,2,20,1,39,12,57,6,59,2,65,4,74,2,130,1,75,2,0,0,73,231,38,114,100,231,63,255,243,152,147,255,252,255,255,255,255,255,36,147,132],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_16",
      fan: "AC_FAN_MID",
      command: [227,0,5,62,2,244,0,53,2,69,4,70,12,65,6,81,2,65,1,76,2,0,0,43,27,21,186,212,108,92,120,241,227,163,98,177,226,171,197,99,199,143,30,60,120,241,227,198,174,194],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_17",
      fan: "AC_FAN_MID",
      command: [227,0,5,37,12,71,6,62,2,244,0,49,2,67,4,80,2,66,1,68,2,0,0,146,138,81,37,42,74,72,165,18,162,168,170,42,136,165,74,36,162,168,164,149,82,81,84,69,69,81,21,21,69,81,84,85,21,68,164,169,16,128],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_MID",
      command: [227,0,5,66,2,242,0,75,2,48,4,46,12,42,6,84,2,65,1,86,2,0,0,43,27,21,186,212,108,92,120,241,227,163,98,177,226,215,138,199,143,30,60,120,241,227,199,142,187,8],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_MID",
      command: [227,0,5,65,2,13,1,71,2,54,4,45,12,56,6,103,2,110,1,76,2,0,0,43,221,110,181,221,255,255,187,21,255,95,95,255,255,255,255,214,236,32],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_MID",
      command: [227,0,5,60,2,9,1,37,12,54,6,69,2,71,4,75,2,110,1,77,2,0,0,73,140,228,206,76,156,231,241,255,206,98,79,228,207,147,31,227,255,255,255,243,57,132],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_MID",
      command: [227,0,5,67,2,244,0,37,12,48,6,70,2,62,4,86,2,65,1,77,2,0,0,73,140,228,206,76,156,196,227,199,143,28,140,196,152,241,153,226,76,120,241,227,199,143,30,60,120,156,230,16],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_MID",
      command: [227,0,5,64,2,251,0,72,2,54,4,33,12,60,6,88,2,64,1,74,2,0,0,43,221,110,181,221,199,143,30,59,177,88,241,119,214,60,120,241,227,199,143,30,60,123,176,128],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_MID",
      command: [227,0,5,49,2,10,1,72,2,32,4,43,12,52,6,82,2,110,1,78,2,0,0,43,221,110,181,221,255,255,187,21,248,247,215,227,255,255,255,254,175,97,0],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_MID",
      command: [227,0,5,66,2,4,1,36,12,55,6,75,2,48,4,76,2,72,1,80,2,0,0,73,231,38,114,100,140,231,241,254,57,204,73,143,146,126,79,199,143,31,227,199,248,252,158,97,0],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_MID",
      command: [227,0,5,69,2,243,0,44,12,45,6,80,2,50,4,82,2,62,1,76,2,0,0,73,140,196,153,201,147,152,156,120,241,227,145,152,147,30,50,124,73,143,30,60,120,241,227,199,143,19,35,145,8],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_MID",
      command: [227,0,5,60,2,20,1,44,2,71,4,35,12,72,6,74,2,115,1,72,2,0,0,43,221,110,181,221,255,255,187,21,253,191,95,255,255,255,255,247,176,128],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_MID",
      command: [227,0,5,47,2,18,1,43,12,49,6,61,2,67,4,73,2,112,1,82,2,0,0,73,231,38,114,100,231,63,255,243,152,147,254,126,79,255,255,255,255,228,199,48,128],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_MID",
      command: [227,0,5,48,2,19,1,40,12,52,6,60,2,62,4,73,2,94,1,95,2,0,0,73,231,38,114,100,231,56,255,31,206,98,79,228,254,79,255,255,255,255,243,230,16],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_MID",
      command: [227,0,5,64,2,1,1,53,2,56,4,43,12,70,6,76,2,67,1,75,2,0,0,43,27,21,186,212,110,227,199,143,29,27,21,143,27,31,88,241,227,199,143,31,227,199,220,118,16],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_MID",
      command: [227,0,5,55,2,18,1,68,2,65,4,33,12,51,6,74,2,116,1,79,2,0,0,43,221,110,181,221,255,255,187,21,253,254,191,255,255,255,255,254,194],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_31",
      fan: "AC_FAN_MID",
      command: [227,0,5,69,2,239,0,74,2,48,4,41,12,57,6,87,2,60,1,77,2,0,0,43,27,173,214,163,98,227,199,143,29,216,172,120,241,226,177,227,199,143,30,60,120,241,226,170,177,8],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_16",
      fan: "AC_FAN_HIGH",
      command: [227,0,5,61,2,16,1,37,12,74,6,46,2,69,4,73,2,120,1,70,2,0,0,73,231,38,114,100,231,63,255,243,152,147,249,36,249,159,255,255,255,255,249,152,64],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_17",
      fan: "AC_FAN_HIGH",
      command: [227,0,5,65,2,254,0,32,12,48,6,75,2,57,4,90,2,68,1,96,2,0,0,73,140,228,206,76,145,156,254,60,120,231,49,38,60,100,159,51,227,199,143,30,60,120,241,242,73,204,32],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_HIGH",
      command: [227,0,5,61,2,17,1,55,12,48,6,70,2,69,4,47,2,93,1,74,2,0,0,73,140,228,206,76,145,156,255,255,206,98,79,230,79,153,255,255,255,255,252,147,152,64],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_HIGH",
      command: [227,0,5,59,2,16,1,35,12,75,6,48,2,67,4,69,2,132,1,69,2,0,0,73,231,38,114,100,231,63,255,243,152,147,254,79,153,255,255,255,255,249,147,152,64],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_HIGH",
      command: [227,0,5,39,12,68,6,57,2,243,0,55,2,64,4,75,2,56,1,66,2,0,0,146,138,81,37,42,74,72,165,18,162,168,170,42,138,145,74,36,162,168,146,149,17,41,20,81,81,17,81,21,21,68,81,17,20,69,69,81,82,84,136,64],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_HIGH",
      command: [227,0,5,46,2,13,1,72,2,66,4,42,12,48,6,73,2,115,1,75,2,0,0,43,221,110,181,216,184,255,254,236,87,251,125,191,255,255,255,255,91,176,128],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_HIGH",
      command: [227,0,5,68,2,254,0,77,2,43,4,36,12,47,6,99,2,80,1,93,2,0,0,43,221,110,181,221,199,143,31,221,138,254,239,183,252,120,241,227,199,143,30,54,236,32],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_HIGH",
      command: [227,0,5,66,2,6,1,37,12,47,6,73,2,66,4,112,2,123,1,76,2,0,0,73,140,228,206,76,156,231,30,63,249,204,73,143,243,230,127,255,255,255,254,115,152,64],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_HIGH",
      command: [227,0,5,58,2,238,0,41,12,62,6,62,2,66,4,83,2,67,1,82,2,0,0,73,140,196,153,201,146,51,19,143,30,60,114,51,18,99,196,146,60,76,143,30,60,120,241,227,199,143,30,115,8],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_HIGH",
      command: [227,0,5,67,2,241,0,47,12,51,6,71,2,66,4,87,2,56,1,99,2,0,0,73,140,228,206,76,145,152,156,120,241,227,145,152,147,30,50,71,137,145,227,199,143,30,60,120,241,226,73,28,194],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_HIGH",
      command: [227,0,5,65,2,241,0,49,12,69,6,46,2,73,4,73,2,64,1,73,2,0,0,73,140,196,153,201,146,51,19,143,30,60,114,51,18,99,196,200,241,50,60,120,241,227,199,143,30,60,100,142,68,32],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_HIGH",
      command: [227,0,5,67,2,253,0,30,12,49,6,80,2,49,4,74,2,65,1,72,2,0,0,73,231,38,114,100,231,56,241,227,199,35,49,39,227,159,153,241,227,199,143,30,60,120,241,51,204,32],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_HIGH",
      command: [227,0,5,57,2,239,0,70,2,60,4,30,12,41,6,81,2,63,1,78,2,0,0,43,27,21,186,212,108,92,120,241,227,163,98,177,226,177,226,209,227,199,143,30,60,120,241,227,163,162,16],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_HIGH",
      command: [227,0,5,58,2,19,1,53,2,75,4,44,12,71,6,105,2,116,1,77,2,0,0,43,221,110,181,221,255,255,187,21,254,254,223,255,255,255,255,175,176,128],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_HIGH",
      command: [227,0,5,65,2,8,1,36,12,48,6,74,2,57,4,78,2,110,1,78,2,0,0,73,231,38,114,100,231,56,255,254,115,18,127,56,249,159,255,241,255,255,249,243,8],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_31",
      fan: "AC_FAN_HIGH",
      command: [227,0,5,51,2,3,1,62,2,61,4,46,12,62,6,74,2,73,1,100,2,0,0,43,27,173,214,163,119,30,63,199,118,43,30,60,125,190,60,120,241,227,199,143,251,142,194],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_16",
      fan: "AC_FAN_AUTO",
      command: [227,0,5,81,2,234,0,87,2,40,4,63,12,29,6,114,2,44,1,113,2,0,0,43,27,21,186,212,108,92,120,241,227,163,98,227,234,188,120,241,227,199,143,30,60,120,251,187,8],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_17",
      fan: "AC_FAN_AUTO",
      command: [227,0,5,87,2,42,4,73,2,234,0,59,12,30,6,105,2,48,1,113,2,0,0,58,45,118,187,139,70,162,168,170,42,138,197,163,81,84,94,168,170,42,138,162,168,170,42,138,162,168,170,42,138,181,161,0],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_AUTO",
      command: [227,0,5,70,2,237,0,56,2,69,4,48,12,56,6,89,2,55,1,98,2,0,0,43,27,21,186,212,108,92,120,241,227,163,98,227,237,120,241,227,199,143,30,60,120,241,226,168,236,32],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_AUTO",
      command: [227,0,5,77,2,232,0,82,2,53,4,60,12,34,6,111,2,44,1,114,2,0,0,43,27,173,214,163,119,30,60,120,232,216,184,241,215,143,30,60,120,241,227,199,143,30,53,29,132],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_AUTO",
      command: [227,0,5,81,2,235,0,85,2,44,4,59,12,39,6,112,2,46,1,95,2,0,0,43,27,173,214,163,119,30,60,120,238,197,199,138,222,60,120,241,227,199,143,30,60,120,183,176,128],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_AUTO",
      command: [227,0,5,76,2,234,0,88,2,48,4,56,12,31,6,111,2,47,1,120,2,0,0,43,27,173,214,163,119,30,60,120,232,216,184,241,183,143,30,60,120,241,227,199,143,30,59,216,64],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_AUTO",
      command: [227,0,5,78,2,233,0,91,2,49,4,55,12,29,6,115,2,47,1,95,2,0,0,43,221,110,181,216,184,241,227,199,118,46,62,239,30,60,120,241,227,199,143,30,62,190,194],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_AUTO",
      command: [227,0,5,84,2,233,0,92,2,42,4,59,12,33,6,116,2,46,1,96,2,0,0,43,27,173,214,187,184,241,254,59,177,127,30,241,227,199,143,30,60,120,241,227,198,251,8],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_AUTO",
      command: [227,0,5,85,2,232,0,89,2,40,4,53,12,38,6,93,2,40,1,95,2,0,0,43,221,110,181,27,191,143,30,58,54,46,62,175,143,30,60,120,241,227,199,143,31,113,216,64],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_AUTO",
      command: [227,0,5,81,2,232,0,90,2,47,4,62,12,31,6,115,2,43,1,102,2,0,0,43,27,173,214,187,184,241,227,199,118,46,60,107,227,199,143,30,60,120,241,227,199,143,29,132],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_AUTO",
      command: [227,0,5,83,2,234,0,83,2,48,4,69,12,32,6,113,2,39,1,92,2,0,0,43,221,110,181,216,184,241,227,199,118,46,62,223,30,60,120,241,227,199,143,30,60,85,86,33,0],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_AUTO",
      command: [227,0,5,82,2,233,0,87,2,38,4,53,12,35,6,115,2,42,1,109,2,0,0,43,27,21,186,212,108,92,120,241,227,187,23,30,58,60,120,241,227,199,143,30,60,120,241,170,184,64],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_AUTO",
      command: [227,0,5,88,2,231,0,55,12,38,6,85,2,44,4,116,2,36,1,94,2,0,0,73,231,38,114,100,230,39,30,60,120,228,102,39,31,39,227,199,143,30,60,120,241,227,199,201,146,98,16],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_AUTO",
      command: [227,0,5,84,2,232,0,90,2,21,4,64,12,32,6,117,2,43,1,118,2,0,0,43,27,173,214,187,184,241,227,199,118,46,63,126,60,120,241,227,199,143,30,60,120,234,184,64],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_AUTO",
      command: [227,0,5,84,2,234,0,104,2,37,4,60,12,19,6,113,2,45,1,119,2,0,0,43,27,173,214,187,184,241,227,199,70,197,199,220,120,241,227,199,143,30,60,120,241,245,171,132],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_31",
      fan: "AC_FAN_AUTO",
      command: [227,0,5,85,2,232,0,88,2,41,4,59,12,28,6,115,2,45,1,116,2,0,0,43,27,21,186,215,119,241,227,199,70,197,199,143,30,60,120,241,227,199,143,30,60,120,218,184,64],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_16",
      fan: "AC_FAN_LOW",
      command: [227,0,5,70,2,234,0,47,12,31,6,79,2,53,4,103,2,50,1,103,2,0,0,73,140,196,153,201,146,51,19,143,30,60,114,51,19,143,18,73,227,49,227,199,143,30,60,120,241,242,103,48,128],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_17",
      fan: "AC_FAN_LOW",
      command: [227,0,5,83,2,233,0,91,2,48,4,67,12,26,6,113,2,45,1,122,2,0,0,43,27,173,214,163,119,30,63,199,70,197,199,141,94,55,227,199,143,30,60,120,241,227,110,194],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_LOW",
      command: [227,0,5,70,2,231,0,64,12,20,6,92,2,38,4,112,2,41,1,95,2,0,0,73,140,228,206,76,145,152,156,120,241,227,156,196,227,230,79,25,143,241,227,199,143,30,60,120,156,228,66],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_LOW",
      command: [227,0,5,85,2,232,0,84,2,45,4,74,12,27,6,113,2,46,1,115,2,0,0,43,221,110,181,221,199,143,30,58,54,46,60,117,227,126,60,120,241,227,199,143,30,61,216,64],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_LOW",
      command: [227,0,5,81,2,231,0,89,2,33,4,55,12,37,6,111,2,37,1,109,2,0,0,43,216,173,214,163,98,227,199,143,29,216,184,250,222,55,227,199,143,30,60,120,241,226,168,236,32],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_LOW",
      command: [227,0,5,77,2,234,0,91,2,40,4,59,12,25,6,113,2,46,1,99,2,0,0,43,27,173,214,187,184,241,254,59,177,113,227,111,27,30,60,120,241,227,199,143,30,53,29,132],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_LOW",
      command: [227,0,5,77,2,234,0,89,2,58,4,58,12,34,6,109,2,47,1,111,2,0,0,43,27,173,214,163,119,30,60,120,232,216,184,241,119,141,143,30,60,120,241,227,199,143,183,176,128],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_LOW",
      command: [227,0,5,80,2,233,0,82,2,44,4,57,12,43,6,114,2,47,1,115,2,0,0,43,27,173,214,187,23,30,60,120,232,216,184,241,239,27,241,227,199,143,30,60,120,241,209,216,64],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_LOW",
      command: [227,0,5,79,2,233,0,88,2,50,4,49,12,33,6,111,2,44,1,121,2,0,0,43,27,21,186,215,98,227,199,143,29,27,23,30,42,143,27,30,60,120,241,227,199,143,30,43,29,132],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_LOW",
      command: [227,0,5,80,2,231,0,88,2,46,4,53,12,34,6,113,2,44,1,124,2,0,0,43,27,173,214,163,119,30,60,120,238,197,199,141,124,108,120,241,227,199,143,30,60,120,223,97,0],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_LOW",
      command: [227,0,5,81,2,234,0,87,2,40,4,55,12,38,6,83,2,43,1,126,2,0,0,43,27,173,214,163,119,30,60,120,238,197,199,218,60,108,120,241,227,199,143,30,60,120,191,97,0],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_LOW",
      command: [227,0,5,81,2,231,0,90,2,44,4,51,12,37,6,113,2,36,1,123,2,0,0,43,27,173,214,163,98,227,199,143,29,216,184,241,223,27,241,227,199,143,30,60,120,241,227,176,128],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_LOW",
      command: [227,0,5,80,2,234,0,87,2,46,4,47,12,29,6,109,2,46,1,111,2,0,0,43,27,21,186,212,110,227,199,143,29,216,184,250,199,141,143,30,60,120,241,227,199,143,21,85,194],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_LOW",
      command: [227,0,5,80,2,232,0,57,12,28,6,89,2,42,4,114,2,44,1,111,2,0,0,73,140,228,206,76,156,231,30,60,120,231,49,56,241,159,140,199,143,30,60,120,241,227,199,140,146,78,16],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_LOW",
      command: [227,0,5,77,2,232,0,88,2,46,4,56,12,32,6,115,2,43,1,124,2,0,0,43,27,173,214,163,119,30,60,120,238,197,199,223,198,199,143,30,60,127,143,30,60,90,174,16],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_31",
      fan: "AC_FAN_LOW",
      command: [227,0,5,82,2,232,0,98,2,29,4,50,12,35,6,111,2,46,1,82,2,0,0,43,27,173,214,163,119,30,60,120,238,197,199,143,30,54,60,127,143,241,227,199,143,29,86,33,0],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_16",
      fan: "AC_FAN_MID",
      command: [227,0,5,47,12,61,6,49,2,62,4,69,2,240,0,82,2,60,1,74,2,0,0,169,18,145,82,146,165,68,164,82,68,146,36,145,36,137,40,148,138,72,146,69,84,146,42,68,146,36,145,36,137,36,73,34,73,18,72,146,68,146,36,169,40,132],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_17",
      fan: "AC_FAN_MID",
      command: [227,0,5,69,2,237,0,51,12,48,6,71,2,62,4,85,2,57,1,69,2,0,0,73,140,196,153,201,146,51,19,143,30,60,114,51,19,143,25,39,137,49,227,199,143,30,60,120,241,226,76,228,66],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_MID",
      command: [227,0,5,81,2,233,0,86,2,42,4,56,12,41,6,113,2,46,1,116,2,0,0,43,221,110,181,221,199,143,30,59,177,113,246,190,177,227,199,143,30,60,120,241,227,110,194],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_MID",
      command: [227,0,5,82,2,233,0,55,12,32,6,86,2,50,4,82,2,45,1,90,2,0,0,73,231,38,114,100,140,231,30,60,120,231,49,56,241,201,242,99,199,143,30,60,120,241,227,196,231,48,128],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_MID",
      command: [227,0,5,78,2,232,0,87,2,46,4,69,12,40,6,113,2,44,1,110,2,0,0,43,27,21,186,215,119,30,60,120,238,197,199,138,222,43,30,60,120,241,227,199,143,30,61,216,64],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_MID",
      command: [227,0,5,79,2,233,0,87,2,37,4,81,12,36,6,108,2,46,1,94,2,0,0,43,221,110,181,221,252,120,241,209,177,113,227,111,21,143,30,60,120,241,227,199,143,171,216,64],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_MID",
      command: [227,0,5,81,2,233,0,62,12,22,6,87,2,49,4,112,2,42,1,91,2,0,0,73,140,196,153,201,146,51,156,120,241,227,156,196,227,196,231,137,63,30,60,120,241,227,199,143,25,60,194],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_MID",
      command: [227,0,5,82,2,234,0,91,2,39,4,54,12,33,6,72,2,44,1,96,2,0,0,43,221,110,181,27,23,30,60,120,232,216,184,241,239,21,248,241,227,199,143,30,60,120,183,176,128],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_MID",
      command: [227,0,5,77,2,234,0,83,2,46,4,51,12,33,6,100,2,48,1,116,2,0,0,43,27,21,186,212,110,227,199,143,29,216,184,241,84,120,172,120,241,227,199,143,30,60,120,239,97,0],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_MID",
      command: [227,0,5,61,2,1,1,40,2,79,4,30,12,80,6,75,2,71,1,60,2,0,0,43,27,21,186,212,108,92,120,241,140,116,108,95,245,250,199,248,241,254,60,127,253,99,176,128],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_MID",
      command: [227,0,5,67,2,233,0,90,2,42,4,64,12,31,6,107,2,46,1,117,2,0,0,43,216,173,214,187,23,30,60,120,238,197,252,90,62,177,227,199,143,30,60,120,241,227,99,176,128],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_MID",
      command: [227,0,5,79,2,233,0,61,12,32,6,91,2,40,4,87,2,43,1,111,2,0,0,73,231,38,114,100,140,231,241,227,199,35,49,56,241,207,201,143,30,60,120,241,227,199,143,19,243,8],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_MID",
      command: [227,0,5,79,2,234,0,85,2,40,4,51,12,45,6,112,2,49,1,119,2,0,0,43,27,173,214,187,184,241,227,199,118,46,62,191,21,143,241,227,199,143,30,60,120,241,216,64],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_MID",
      command: [227,0,5,80,2,232,0,84,2,45,4,57,12,43,6,106,2,45,1,94,2,0,0,43,27,21,186,212,110,227,199,143,29,27,23,30,54,62,191,30,60,120,241,227,199,143,170,172,66],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_MID",
      command: [227,0,5,78,2,234,0,86,2,43,4,51,12,38,6,107,2,47,1,89,2,0,0,43,27,173,214,163,119,241,227,199,70,197,254,227,197,99,252,120,241,227,199,143,30,53,86,33,0],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_31",
      fan: "AC_FAN_MID",
      command: [227,0,5,75,2,239,0,51,2,60,4,59,12,59,6,99,2,52,1,111,2,0,0,43,27,173,214,163,98,227,199,143,29,27,23,30,60,125,99,199,143,30,60,120,241,227,197,170,225,0],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_16",
      fan: "AC_FAN_HIGH",
      command: [227,0,5,63,2,242,0,42,2,73,4,17,12,76,6,77,2,57,1,68,2,0,0,43,27,21,186,212,108,92,71,24,196,113,209,177,113,28,85,113,22,227,17,196,113,227,199,143,30,60,106,236,32],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_17",
      fan: "AC_FAN_HIGH",
      command: [227,0,5,71,2,237,0,78,2,54,4,48,12,39,6,87,2,55,1,79,2,0,0,43,27,21,186,212,108,92,120,241,227,163,98,227,198,175,22,143,30,60,120,241,227,199,143,22,186,33,0],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_HIGH",
      command: [227,0,5,68,2,239,0,71,2,51,4,41,12,60,6,96,2,57,1,99,2,0,0,43,27,21,186,212,108,92,120,241,227,163,98,227,237,120,180,120,241,227,199,143,30,60,120,235,176,128],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_HIGH",
      command: [227,0,5,71,2,240,0,72,2,59,4,49,12,36,6,87,2,56,1,77,2,0,0,43,27,21,186,212,108,92,120,241,227,163,98,227,199,94,45,30,60,120,241,227,199,143,30,43,116,66],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_HIGH",
      command: [227,0,5,73,2,234,0,80,2,48,4,42,12,41,6,97,2,55,1,105,2,0,0,43,27,21,186,215,98,227,199,143,29,27,23,30,43,120,180,120,241,227,199,143,30,60,120,219,176,128],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_HIGH",
      command: [227,0,5,74,2,235,0,86,2,41,4,53,12,35,6,94,2,54,1,110,2,0,0,43,27,21,186,212,108,92,120,241,227,163,98,227,198,223,104,241,227,199,143,30,60,120,241,119,97,0],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_HIGH",
      command: [227,0,5,74,2,239,0,83,2,49,4,49,12,43,6,97,2,54,1,88,2,0,0,43,216,173,214,187,23,30,60,120,232,216,184,241,119,139,71,143,30,60,120,241,227,199,143,118,16],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_HIGH",
      command: [227,0,5,69,2,240,0,55,2,67,4,48,12,64,6,84,2,58,1,106,2,0,0,43,27,21,186,212,108,92,120,241,227,163,98,227,199,188,90,60,120,241,227,199,143,30,60,85,29,132],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_HIGH",
      command: [227,0,5,74,2,236,0,39,12,53,6,78,2,48,4,102,2,53,1,111,2,0,0,73,140,196,153,201,146,51,19,143,30,60,114,51,19,143,18,79,137,159,30,60,120,241,227,199,143,25,60,194],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_HIGH",
      command: [227,0,5,69,2,240,0,47,12,48,6,68,2,69,4,79,2,57,1,75,2,0,0,73,140,196,153,201,146,51,19,143,30,60,114,51,19,143,25,35,196,200,241,227,199,143,30,60,120,241,50,57,16,128],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_HIGH",
      command: [227,0,5,79,2,235,0,43,12,43,6,87,2,42,4,81,2,43,1,97,2,0,0,73,230,36,206,76,145,156,227,199,143,28,230,39,30,38,126,103,199,143,30,60,120,241,227,199,35,152,64],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_HIGH",
      command: [227,0,5,78,2,233,0,43,12,38,6,89,2,43,4,104,2,42,1,119,2,0,0,73,230,36,206,76,156,196,227,199,143,28,140,196,227,199,35,230,71,143,30,60,120,241,227,199,201,142,97,0],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_HIGH",
      command: [227,0,5,78,2,235,0,84,2,42,4,57,12,43,6,108,2,49,1,90,2,0,0,43,27,173,214,187,184,241,227,199,70,197,199,138,199,139,124,120,241,227,199,143,30,60,111,176,128],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_HIGH",
      command: [227,0,5,74,2,234,0,87,2,47,4,58,12,32,6,105,2,48,1,109,2,0,0,43,216,173,214,187,184,241,227,199,118,47,227,126,45,30,60,120,241,227,199,143,30,46,59,8],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_HIGH",
      command: [227,0,5,73,2,236,0,84,2,40,4,60,12,40,6,100,2,49,1,87,2,0,0,43,27,173,214,163,98,227,199,143,29,216,184,241,113,226,223,30,60,120,241,227,199,143,30,58,33,0],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_31",
      fan: "AC_FAN_HIGH",
      command: [227,0,5,74,2,236,0,83,2,44,4,40,12,47,6,104,2,48,1,100,2,0,0,43,27,173,214,187,23,30,60,120,232,216,184,241,227,197,163,199,143,30,60,120,241,227,234,171,132],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_NULL",
      fan: "AC_FAN_AUTO",
      command: [227,0,5,70,2,234,0,34,12,65,6,58,2,60,4,82,2,62,1,94,2,0,0,73,140,196,153,201,146,51,19,143,30,60,114,51,25,143,30,120,241,227,199,143,30,60,120,241,226,76,115,8],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_NULL",
      fan: "AC_FAN_LOW",
      command: [227,0,5,67,2,239,0,58,2,61,4,64,12,62,6,83,2,61,1,79,2,0,0,43,27,21,186,212,108,92,120,241,227,163,98,168,241,239,27,30,60,120,241,227,199,143,30,54,236,32],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_NULL",
      fan: "AC_FAN_MID",
      command: [227,0,5,68,2,240,0,60,2,66,4,49,12,53,6,82,2,59,1,100,2,0,0,43,27,21,186,212,108,92,120,241,227,163,98,168,241,239,21,143,30,60,120,241,227,199,143,21,187,8],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_NULL",
      fan: "AC_FAN_HIGH",
      command: [227,0,5,39,2,5,1,14,12,84,6,34,2,95,4,70,2,73,1,70,2,0,0,73,230,36,206,76,145,152,156,120,241,140,114,51,18,79,143,62,103,199,143,31,227,199,143,241,50,115,8],
    },
    {
      mode: "AC_MODE_FEEL",
      temperature: "AC_TEMP_NULL",
      fan: "AC_FAN_AUTO",
      command: [227,0,5,55,2,255,0,44,12,53,6,61,2,72,4,88,2,70,1,74,2,0,0,73,140,228,206,76,145,156,227,199,143,28,140,199,158,60,241,227,199,143,30,60,120,241,227,196,231,48,128],
    },
    {
      mode: "AC_MODE_FEEL",
      temperature: "AC_TEMP_NULL",
      fan: "AC_FAN_LOW",
      command: [227,0,5,59,2,20,1,36,12,58,6,62,2,62,4,76,2,135,1,71,2,0,0,73,231,38,114,100,231,63,255,243,152,243,252,252,255,255,255,255,254,76,230,16],
    },
    {
      mode: "AC_MODE_FEEL",
      temperature: "AC_TEMP_NULL",
      fan: "AC_FAN_MID",
      command: [227,0,5,67,2,239,0,49,12,38,6,79,2,52,4,89,2,66,1,86,2,0,0,73,140,228,206,76,156,196,227,199,143,28,140,199,158,60,241,39,227,199,143,30,60,120,241,227,147,152,64],
    },
    {
      mode: "AC_MODE_FEEL",
      temperature: "AC_TEMP_NULL",
      fan: "AC_FAN_HIGH",
      command: [227,0,5,62,2,18,1,55,12,42,6,63,2,65,4,88,2,132,1,66,2,0,0,73,231,38,114,100,231,63,255,243,152,243,252,249,159,255,255,255,255,201,57,132],
    },
    ]
};

export default PASARGADELECTRIC
